import {animated, useSpring} from '@react-spring/web'

function HomeView() {
    return (
        <div className={'layout vertical gap-large flex-grow'} style={{padding: 'var(--box-padding) 0px'}}>
            <Section i={0} text={'Create your own Escape Rooms'} height={'50%'} button={'Discover Rooms'}/>
            <Section i={1} text={'Create your own Escape Rooms'} height={'25%'} button={'Coming Soon'}/>
            <Section i={2} text={'Create your own Escape Rooms'} height={'25%'} button={''}/>
        </div>
    )
}

function Section(params: {i: number, text: string, height: string, button: string | undefined }) {
    const springs = useSpring({
        delay: params.i * 200,
        from: { x: -60, opacity: 0 },
        to: { x: 0, opacity: 1 },
    })

    return (
        <animated.div style={{
            position: 'relative',
            backgroundColor: 'var(--overlay-color)',
            overflow: 'hidden',
            width: '100%',
            height: params.height,
            borderRadius: '20px',
            boxShadow: 'rgb(0 0 0 / 30%) 5px 5px 20px',
            ...springs
        }}>
            <div style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                height: '30%',
                backgroundImage: 'linear-gradient(0deg, rgb(0 0 0 / 50%), transparent)'
            }}/>
            <div className={'layout horizontal gap'} style={{position: 'absolute', bottom: 0, padding: 'var(--box-padding)', flexGrow: 1}}>
                <p className={'flex-grow'} style={{fontSize: 'var(--font-size-header)', fontWeight: 'bold'}}>{params.text}</p>
                {params.button && <button>{params.button}</button>}
            </div>
        </animated.div>
    )
}

export default HomeView;
